import { useStore } from "react-redux";
import { useNavigate } from "react-router-dom";
import AuthService, { ROLES_ENUM } from "../../service/authService";
import { ROUTES } from "../../constant/common.constant";
import { USER_INFO_ACTION_ENUM } from "../reducers/userInfo";
import { useSelector } from "./useSelector";
import { USER_ADDRESS_ACTION_ENUM } from "../reducers/userAddress";
import { CART_ACTION_ENUM } from "../reducers/cart";

export const useAuth = () => {
  const navigate = useNavigate();
  const { dispatch } = useStore();
  const userInfo = useSelector((state) => state.userInfo);
  const isAdmin = userInfo.isAdmin || userInfo.isDesigner;
  const isDistributor = userInfo.roles.some(
    (role: { role: ROLES_ENUM }) => role.role === ROLES_ENUM.DISTRIBUTOR
  );

  const resetState = () => {
    dispatch({
      type: USER_INFO_ACTION_ENUM.RESET_STATE,
    });
    dispatch({
      type: USER_ADDRESS_ACTION_ENUM.RESET_STATE,
    });
    dispatch({
      type: CART_ACTION_ENUM.RESET_STATE,
    });
  };

  const logout = async () => {
    await AuthService.logOut();
    resetState();
    navigate(ROUTES.LOGIN);
  };

  const refetchUserInfo = async () => {
    const userInfo = await AuthService.getUserInfo();

    // Fetch fresh profile image URL from the server
    const userImageUrl =
      (await AuthService.getUserImageUrl())?.data?.data ?? "";

    dispatch({
      type: USER_INFO_ACTION_ENUM.UPDATE_USER_INFO,
      payload: { ...userInfo, imageUrl: userImageUrl },
    });
  };

  return { logout, isAdmin, isDistributor, userInfo, refetchUserInfo };
};
